//@ts-ignore
import React, { useEffect, useState } from 'react';
import { MenuNavProps } from './types';
import { Collapse, List, ListItem } from 'src/components/mui';
import { ListItemStyle } from './styles';
import { Icon } from '../icon/Icon';

export default function MenuNav(props: MenuNavProps) {
  const { menus, openMenu, loadModel, rtl, menuRef, menuColors, whitelabel } = props;
  const { text, active, openedMenuColor, scrollbarColor } = menuColors;
  const { secondaryColor } = whitelabel;
  const [menusState, setMenusState] = useState([]);
  useEffect(() => {
    setMenusState(menus);
  }, [menus]);

  return (
    <List
      id="menu"
      className={rtl ? 'rtl' : ''}
      ref={menuRef}
      sx={{
        maxHeight: '40vh',
        overflowY: 'auto',
        fontSize: '0.9em',
        marginBottom: '20px',
        padding: 0,
        '&::-webkit-scrollbar': {
          width: '8px',
        },
        '&::-webkit-scrollbar-track': {
          backgroundColor: 'transparent',
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: scrollbarColor || secondaryColor || 'red',
          borderRadius: '2px',
        },
      }}
    >
      {menusState &&
        menusState.map((menu: any, i: number) =>
          menu.subMenus && menu.subMenus.length > 0 ? (
            <React.Fragment key={i}>
              <ListItem
                sx={ListItemStyle({
                  text,
                  active,
                  openedMenuColor: menu.open ? openedMenuColor : undefined,
                })}
                onClick={() => {
                  openMenu(i, null);
                }}
              >
                {menu.title}
                <Icon icon={menu.open ? 'fas fa-caret-up' : 'fas fa-caret-down'} />
              </ListItem>
              <Collapse in={menu.open} timeout="auto" unmountOnExit>
                <List sx={{ marginLeft: '10px' }}>
                  {menu.subMenus.map((subMenu: any, j: number) =>
                    subMenu.subSubMenus && subMenu.subSubMenus.length > 0 ? (
                      <React.Fragment key={j}>
                        <ListItem
                          sx={ListItemStyle({
                            text,
                            active,
                            openedMenuColor: subMenu.open ? openedMenuColor : undefined,
                          })}
                          onClick={() => {
                            openMenu(i, j);
                          }}
                        >
                          {subMenu.title}
                          <Icon icon={subMenu.open ? 'fas fa-caret-up' : 'fas fa-caret-down'} />
                        </ListItem>
                        <Collapse in={subMenu.open} timeout="auto" unmountOnExit>
                          <List sx={{ marginLeft: '10px' }}>
                            {subMenu.subSubMenus.map((subSubMenu: any, x: number) => (
                              <ListItem
                                key={x}
                                onClick={() => loadModel(subSubMenu)}
                                sx={ListItemStyle({ text, active })}
                              >
                                {subSubMenu.title}
                              </ListItem>
                            ))}
                          </List>
                        </Collapse>
                      </React.Fragment>
                    ) : (
                      <ListItem
                        key={j}
                        onClick={() => loadModel(subMenu)}
                        sx={ListItemStyle({ text, active })}
                      >
                        {subMenu.title}
                      </ListItem>
                    ),
                  )}
                </List>
              </Collapse>
            </React.Fragment>
          ) : (
            <ListItem
              key={i}
              onClick={() => {
                loadModel(menu);
              }}
              sx={ListItemStyle({ text, active })}
            >
              {menu.title}
            </ListItem>
          ),
        )}
    </List>
  );
}
